import React from 'react';
import classlist from 'utils/classlist';

interface StepItemProps {
    isActive: boolean;
    isComplete: boolean;
    step: number;
    index: number;
    node?: React.ReactNode;
    activeNode?: React.ReactNode;
    className?: string;
    children: React.ReactNode;
}

const StepItem: React.FC<StepItemProps> = ({ isActive, isComplete, index, children, node, className, activeNode }) => {
    return (
        <div
            className={classlist('comp-step-item', `comp-step-item-${index}`, className, {
                'comp-step-item-active': isActive,
                'comp-step-item-complete': isComplete
            })}>
            <div className="comp-step-item-graph">
                <span className="left" />
                {/* {node || <span className="dot">&nbsp;</span>} */}
                {isActive && activeNode ? activeNode : node || <span className="dot">&nbsp;</span>}
                <span className="right" />
            </div>
            {children}
        </div>
    );
};

export default StepItem;
